import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { WalletProvider } from './contexts/WalletContext';
import { SettingsProvider } from './hooks/useSettings';
import ThemeProvider from './theme';
import useWeb3Sync from './hooks/useWeb3Sync';
import useWalletInit from './hooks/useWalletInit';
import Layout from './components/Layout';
import PublicLayout from './components/PublicLayout'; 
import HomePage from './pages/HomePage';
import AssetsListPage from './pages/AssetsListPage';
import AssetsDetailPage from './pages/AssetsDetailPage';
import AssetsMintPage from './pages/AssetsMintPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ContactUsPage from './pages/ContactUsPage';
import AboutPage from './pages/AboutPage';
import NotFoundPage from './pages/NotFoundPage';
import PermissionGuard from './components/PermissionGuard';
import PermissionCheck from './pages/PermissionCheck'; 
import AssetsKycPage from './pages/AssetsKycPage'; 


function AppContent() {
  useWalletInit(); // 钱包初始化
  useWeb3Sync(); // Web3状态同步
  
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        {/* 公共页面路由 */}
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<HomePage />} />
          <Route path="assets" element={<AssetsListPage />} />
          <Route path="assets/:tokenId" element={<AssetsDetailPage />} />
          <Route path="mint" element={
             <PermissionGuard requireConnection>
                <AssetsMintPage />
              </PermissionGuard> } />
         <Route path="assets-kyc/:tokenId" element={
             <PermissionGuard requireConnection>
                <AssetsKycPage />
              </PermissionGuard> } />
          <Route path="about" element={<AboutPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="terms-of-service" element={<TermsOfServicePage />} />
          <Route path="contact-us" element={<ContactUsPage />} />
      
          <Route path="permission-check" element={
             <PermissionGuard requireConnection>
                <PermissionCheck />
              </PermissionGuard> 
                 } />
        </Route> 
        
        {/* 全局404路由 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

        <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Router>
  );
}

function App() {
  return (
    <SettingsProvider>
      <ThemeProvider>
        <WalletProvider>
          <AppContent />
        </WalletProvider>
      </ThemeProvider>
    </SettingsProvider>
  );
}

export default App;